$.fn.zap = function () {
  return this.each(function(){ $(this.childNodes).insertBefore(this); }).remove();
};
var searchResults = {
	missingMapThmb: function(){
		$(".itinerary-map-link img").error(function () {
			$(this).unbind("error").attr("src", "/images/global/itinerary/details/port_image_small.jpg");
		});
	},
	missingMapImg: function(){
		$("#itinerary img").error(function () {
			$(this).unbind("error").attr("src", "/images/global/itinerary/details/map_na.jpg");
		});	
	}
}
$(document).ready(function() {
	searchResults.missingMapThmb();
	(resType == 'C') ? buildDates('#'+type,'','input') : buildDates('','#'+type,'input');	
	var numToCompare = 0;			
	$.when( getData ).then(function(){	
		$.ajax({
			type: "GET",
			cache: false,
			url: '/find/getCompareList.rdat?resType='+resType+'&bID='+$('#searchResultsForm input[name=bID]').val(),
			dataType: "html",
			success: function( results ){		
				if( $.trim(results) != '' ){
					$(results).filter('input').each(function(){ 					
						var voyageId = $(this).attr('data-voyage-id');
						var tourId =  $(this).attr('data-tour-id');
					
						var voyageToCheck= ( resType == 'C' ) ? $('#search-results').find('span[data-voyage-id='+voyageId+']') : $('#search-results').find( 'span[data-tour-id='+tourId+']');
					
						voyageToCheck.closest('.results-node').find('a.add-to-compare').addClass('go-to-compare').removeClass('add-to-compare').text('Compare Now').siblings('input').prop('checked',true);
					
						numToCompare++;
					});
					$('#compare-cruises-block').append(results);
				}
			},
			error: function(req,error){
				if(error === 'error'){error = req.statusText;}
					alert('An error has occurred.');
			}
		});
		//listFbLike();
	});
	
	
	$(document).on('click', "#search-results .pricing-details a.button:not('.show-all-staterooms'), #search-results .pricing-expanded a.button", function(){		
		var voyageId = $(this).attr('data-voyage-id');
		var tourId = (resType == 'T') ? $(this).attr('data-tour-id') : "";
		var itinId = $(this).closest('.results-node').children('input:hidden').val();
		if( typeof itinId === "undefined" || itinId == "" ){
			itinId = $(this).attr('data-itin-id');
		}
		
		var searchForm = $('#searchResultsForm');
		
		document.cruiseDetailForm.trade.value = document.searchResultForm.trade.value;
		document.cruiseDetailForm.voyageCode.value = voyageId;
		document.cruiseDetailForm.tourCode.value = tourId;
		document.cruiseDetailForm.itinCode.value = itinId;
		document.cruiseDetailForm.ship.value = document.searchResultForm.ship.value;
		document.cruiseDetailForm.resType.value = resType;
		
		document.cruiseDetailForm.date.value = document.searchResultForm.date.value;
    	document.cruiseDetailForm.bID.value = document.searchResultForm.bID.value;
    	document.cruiseDetailForm.itinPort.value = document.searchResultForm.itinPort.value;
    	document.cruiseDetailForm.meta.value = $('.select-room-type input:radio:checked').val();
    	document.cruiseDetailForm.ppax.value = $('#searchResultsForm input[name=ppax]').is(':checked'); 
    	document.cruiseDetailForm.noOfPax.value = $('#pax-per-room option:selected').val();
    	document.cruiseDetailForm.submit();
	});
	
	//Add to compare
	$(document).on('click', '.add-to-compare, .compare-cruises input', function(e) {
		
		e.stopPropagation();
		if( $(this).hasClass('inactive') ){
			return false;
		}
		var target = $(this);
		
		var resType = $('#searchResultsForm input[name=resType]').val();
		var bID = $('#searchResultsForm input[name=bID]').val();
		var voyage = $(this).closest('.results-node').find('span.inactive');
		var voyageId = voyage.attr('data-voyage-id');
		var tourId = (resType == 'T') ? voyage.attr('data-tour-id') : "";
		var itinId = $(this).closest('.results-node').children('input:hidden').val();
		
		if( target.is('input') && !target.is(':checked') ){
			$.ajax({
				type: "GET",
				cache: false,
				url: '/find/removeFromCompare.rdat?itinCode='+itinId+'&voyageCode='+voyageId+'&tourCode='+tourId+'&bID='+bID+'&resType='+resType,
				dataType: "html",
				success: function( results ){
					if( results == 'true' ){
						$('#compare-'+itinId).remove();
						target.siblings('a').text('Add to Compare').removeClass('go-to-compare').addClass('add-to-compare');
						(numToCompare == 4) ?numToCompare = 2 : numToCompare--;
					}
				},
				error: function(req,error){
					if(error === 'error'){error = req.statusText;}
						alert('An error has occurred.');
				}
			});
			return;
		} 

		
		/*
		if(numToCompare < 4) {
			numToCompare++;
		}*/
		

		if( numToCompare+1 > 3 ){
			//alert("Max of 3 allowed.");
			numToCompare = 4;
			$('input[id="compare-'+voyageId+'"]').prop('checked',false);
		}
		else{

			$.ajax({
				type: "GET",
				cache: false,
				url: '/find/addToCompare.rdat?itinCode='+itinId+'&voyageCode='+voyageId+'&tourCode='+tourId+'&resType='+resType+'&bID='+bID,
				dataType: "html",
				success: function( results ){
					
					$('#compare-cruises-block').append(results);
					
					var compareNow = 'Compare Now';
					if( target.is('input') ){
						target.siblings('a').text(compareNow).addClass('go-to-compare').removeClass('add-to-compare');
					}
					else{
						target.text(compareNow).addClass('go-to-compare').removeClass('add-to-compare');
						target.siblings('input').prop('checked',true);
					}
					numToCompare++;
				},
				error: function(req,error){
					if(error === 'error'){error = req.statusText;}
					alert('An error has occurred.');
				}
			});

		}
		
		$(this).qtip({
			overwrite: false,
			content: {
				text: function(){
					var $qtipHeader = '<div class="qtipHeader centerAlign">Your selection has been added.</div>';
					var noToCompare = numToCompare;
					if(numToCompare > 4){
						noToCompare = 4;
					}
					switch(noToCompare){
					case 0:	
					case 1:
							return $qtipHeader + '<div class="centerAlign">Select one more voyage to compare</div>';
						case 4:
							return '<div class="qtipHeader centerAlign">You can compare up to 3 voyages at a time.</div><div class="centerAlign"><a href="" class="qTipCompare">Click here to compare your selected voyages now</a></div>';
						default:
							return $qtipHeader + '<div class="centerAlign"><a href="" class="qTipCompare">Click here to compare your selected voyages now</a></div>';
					}

				}
			},
			position: {
				effect: false,
				my: 'bottom center',
				at: 'center center',
				viewport: $(window),
                target: 'mouse',
				adjust: {
                    mouse: false
                }
			},
			show: {
				solo: true,
				event: e.type,
				ready: true,
				delay: 150
			}, 
			hide: {
				fixed: true,
				delay: 100
			}, 
			style: {
				classes: 'ui-tooltip-princess',
				tip: false
			}
	}, e);
		
		if($( e.target ).is( 'a' )){
			return false;
		}
		
	});
	$(document).on('click', '.compare-link, .go-to-compare', function(e){
		e.preventDefault();
		if(numToCompare < 2){
				$(this).qtip({
					overwrite: false,
					content: {
						text: function(){
							switch(numToCompare){
							case 0:
							  return '<div class="qtipHeader centerAlign">You have not chosen any cruises to compare.</div><div class="centerAlign">Select more than one voyage to compare</div>';
							default:
							  return '<div class="qtipHeader centerAlign">Select one more voyage to compare</div>';
							}
						}
					},
					position: {
						effect: false,
						my: 'bottom center',
						at: 'center center',
						viewport: $(window),
						target: 'mouse',
						adjust: {
							mouse: false
						}
					},
					show: {
						solo: true,
						event: e.type,
						ready: true,
						delay: 150
					}, 
					hide: {
						fixed: true,
						delay: 100
					}, 
					move: {
						effect: function() { 
								$(this).qtip("destroy"); 
							}
					},
					style: {
						classes: 'ui-tooltip-princess',
						tip: false
					}
				}, e);
		}else{
			gotoCompare();		
		}
	});
	

	function gotoCompare(){
		var compareVoyages = $('#compare-cruises-block input');
		if( compareVoyages.length >= 2 ){
			location.href="/find/viewCompareList.do?"+$('#searchResultsForm input[name!=ship]').serialize();
		}
	}
	
	$(document).on('click', '#compare-cruises a, .go-to-compare, .qTipCompare', function(){
		gotoCompare();
		return false;
	});
	
	$(document).on('click', '.cruise-title-ships a', function(){
		$(this).closest('.results-node').find('.pricing-details').not(':hidden').children('.button').trigger('click');
		return false;
	});	
	
	$(document).on('click', '.depart-date a', function(){
		var drawerStateOpen = !$(this).closest('.results-node').find('.view-additional-fares').hasClass('closed');
		var prev = $(this).closest('.cruise-dates').find('span.inactive');
		var day = prev.text();
		var searchForm = $('#searchResultsForm input[name!=ship][name!=meta]');
		
		prev.text('');
		prev.append('<a href="javascript:void(0);">'+day+'</a>');
		prev.removeClass('inactive');
		
		day = $(this).text();
		
		var itinId = $(this).closest('.results-node').children('input:hidden').val();
		var voyageId = $(this).parent().attr('data-voyage-id');
		var tourId = $(this).parent().attr('data-tour-id');
		var shipCodes = $(this).closest('.results-node').find('#'+itinId+'-ship-codes').val();
		var meta = $('.select-room-type input:radio:checked').val();
		
		$(this).parent().addClass('inactive');
		$(this).parent().text(day);
		$(this).remove();
		
		/*Check if added to compare list, if not, make it active again*/
		
		var inCompare = $('#compare-'+itinId);
		if( inCompare.length > 0 ){
			
			inCompare.attr('data-voyage-id',voyageId);
			if( resType=='T' ){
				inCompare.attr('data-tour-id',tourId);
			}
			var bID = $('#searchResultsForm input[name=bID]').val();
			$.get('/find/addToCompare.rdat?itinCode='+itinId+'&voyageCode='+voyageId+'&tourCode='+tourId+'&resType='+resType+'&bID='+bID);
		}
		
		$.ajax({
			type: "GET",
			cache: false,
			url: "/find/getFares.rdat?metaChange=true&itinCode="+itinId+"&voyageCode="+voyageId+"&tourCode="+tourId+"&index=0&meta="+meta+"&"+searchForm.serialize()+"&ship="+shipCodes,
			dataType: "html",
			success: function( results ){
				removePromoElements($(results));
				if( drawerStateOpen ){
					$(results).find('.show-all-staterooms').addClass('deactive');
				}
				else{
					prev.closest('.results-node').find('.pricing-expanded').remove();
				}
				
				//var meta = $('.select-room-type input:radio:checked').val();
				prev.closest('.results-node').find('div[class*="pricing-details"]').remove();
				//prev.closest('.results-node').find('.itinerary-summary-ports-dates').after(results);
				
				$(results).hide().insertAfter(prev.closest('.results-node').find('.itinerary-summary-ports-dates'));
				var metaToShow = prev.closest('.results-node').find('.meta-'+meta);
				( metaToShow.length > 0 ) ?  metaToShow.fadeIn('slow') : prev.closest('.results-node').find('.pricing-details').fadeIn('slow');
				
				prev.closest('.results-node').find('.to-from-port, .itinerary-update').remove();
				
				prev.closest('.results-node').find('.itinerary-map-link a').attr('href', $(results).filter('.itinerary-update').val());
				
				var toFromPort = $(results).filter('.to-from-port').val();
				if( typeof toFromPort != "undefined" && itinId != ""  ){
					prev.closest('.results-node').find('.itinerary-summary p').html(toFromPort);
					
				}
				
				if( drawerStateOpen ){
					prev.closest('.results-node').find('.show-all-staterooms').addClass('deactive');
					$.ajax({
						type: "GET",
						url: "/find/getFaresAndDates.rdat?itinCode="+itinId+"&voyageCode="+voyageId+"&tourCode="+tourId+"&meta="+meta+"&highlight=true&"+searchForm.serialize()+"&ship="+shipCodes,
						dataType: "html",
						success: function( results ){
							removePromoElements($(results));
							prev.closest('.results-node').find('.pricing-expanded').remove();
							prev.closest('.results-node').append(results);

						},
						error: function(req,error){
							if(error === 'error'){error = req.statusText;}
								alert('An error has occurred.');
						}	
					});
		
				}
				else{
					prev.closest('.results-node').find('.view-additional-fares').trigger('click');
				}
				if($('.govt-tax-fees, .other-pricing-details .see-pay, .gft-summary').length > 0)			
					$(".fuel_supplement").hide();	
			},
			error: function(req,error){
				if(error === 'error'){error = req.statusText;}
							alert('An error has occurred.');
					}
		});
		return false;
	});
	
	
	$('#personal-pricing').change(function(){
		document.cookie = 'cwp' + "=" + escape($(this).is(':checked') ? 'true' : 'false') + "; " + "path=/; domain=localhost; ";
		document.cookie = 'cwp' + "=" + escape($(this).is(':checked') ? 'true' : 'false') + "; " + "path=/; domain=.princess.com; ";
		$("#searchResultsForm").submit();
	});
	
	
	$('.select-room-type input:radio').change(function(){
		$("#searchResultsForm").filter('input[name=meta]').val($('.select-room-type input:radio:checked').val());
	});
	
	//Sort By
	$('#pax-per-room').change( function(){
		$('#searchResultsForm input[name=noOfPax]').val($("option:selected", this).val());
		$('#cruise-occupancy').text(parseInt($("option:selected", this).val()) <= 1 ? 'single' : 'double');
		refreshResults();
		return false;
		
	});
	
		
	// View Additional Fares functionality
	//var drawerStateOpen = false;
	$(document).on('click', '.view-additional-fares', function(){
		var target = $(this);
		var itinId = $(this).closest('.results-node').children('input:hidden').val();
		var voyageId = $(this).closest('.results-node').find('span.inactive').attr('data-voyage-id');
		var tourId = $(this).closest('.results-node').find('span.inactive').attr('data-tour-id');
		var shipCodes = $(this).closest('.results-node').find('#'+itinId+'-ship-codes').val();
		var drawerStateOpen = !$(this).hasClass('closed');
		var searchForm = $("#searchResultsForm input[name!=ship]");
		
		if ( $(this).closest('.actions').next('.pricing-expanded:animated').length ) {
        	return false;
    	}
		else{
			if(drawerStateOpen == false){
				if( $(this).closest('.actions').next('.pricing-expanded').children('.pricing-details-table').length == 0 ){
					$.ajax({
						type: "GET",
						cache: false,
						url: "/find/getFaresAndDates.rdat?itinCode="+itinId+"&voyageCode="+voyageId+"&tourCode="+tourId+"&highlight=true&"+searchForm.serialize()+"&ship="+shipCodes,
						dataType: "html",
						success: function( results ){													
							removePromoElements($(results));						
							target.find('.show-all-staterooms').addClass('deactive');
							target.closest('.actions').next('.pricing-expanded').remove();
							target.closest('.actions').after(results);
							target.closest('.actions').next('.pricing-expanded').hide();
							target.closest('.results-node').find('.show-all-staterooms').addClass('deactive');
							target.closest('.actions').next('.pricing-expanded').slideToggle('medium', function(){
								$("html:not(:animated),body:not(:animated)").animate({ scrollTop: target.closest('.results-node').offset().top }, 1500); 
							});
							target.html(target.html().replace('Show','Hide'));
							target.css('background-position','left -39px');
							target.removeClass('closed');
							if($('.govt-tax-fees, .other-pricing-details .see-pay, .gft-summary').length > 0)			
								$(".fuel_supplement").hide();
						},
						error: function(req,error){
							if(error === 'error'){error = req.statusText;}
								alert('An error has occurred.');
						}
					});
				}
				else{
					$(this).closest('.results-node').find('.show-all-staterooms').addClass('deactive');
					$(this).closest('.actions').next('.pricing-expanded').slideToggle('medium', function(){
						$("html:not(:animated),body:not(:animated)").animate({ scrollTop: target.closest('.results-node').offset().top }, 1500); 
					});
					$(this).html($(this).html().replace('Show','Hide'));
					$(this).css('background-position','left -39px');
					$(this).removeClass('closed');
				}
				
				
			}
			else{
				
				$(this).closest('.actions').next('.pricing-expanded').slideToggle('medium', function(){
					$(this).closest('.results-node').find('.show-all-staterooms').removeClass('deactive');
				});
				$(this).html($(this).html().replace('Hide','Show'));
				$(this).css('background-position','3px 6px');		
				$(this).addClass('closed');
				
			}
			return false;
		}
	});
	
	$(document).on('click', '.show-more', function(){
		var source = $(this);
		var itinId = $(this).closest('.results-node').children('input:hidden').val();
		var voyageId = $(this).children().attr('data-next-voyage');
		var tourId = $(this).children().attr('data-next-tour');
		var target = $(this).closest('.pricing-expanded');
		var shipCodes = $(this).closest('.results-node').find('#'+itinId+'-ship-codes').val();
		var searchForm = $('#searchResultsForm input[name!=ship]');
	
		
		$.ajax({
			type: "GET",
			cache: false,
			url: "/find/getFaresAndDates.rdat?itinCode="+itinId+"&voyageCode="+voyageId+"&tourCode="+tourId+"&"+searchForm.serialize()+"&ship="+shipCodes,
			dataType: "html",
			success: function( results ){
				removePromoElements($(results));
				source.fadeOut();
				//$('input:hidden[name=nextVoyageCode], input:hidden[name=nextTourCode]').remove();
				var data = $(results);
				//target.append(data);
				target.append($('<div class="slider"></div>').append(data).hide());
				$('.slider').delay(100).slideDown(1500,function(){
					$(this).zap();
				});
				target.find('.pricing-expanded').zap();
				if($('.govt-tax-fees, .other-pricing-details .see-pay, .gft-summary').length > 0)			
					$(".fuel_supplement").hide();				
			},
			error: function(req,error){
				if(error === 'error'){error = req.statusText;}
					alert('An error has occurred.');
			}
		});
		return false;
	});
	
	$(document).on('click', '.show-all-staterooms', function(){
		additionalFares = $(this).closest('.results-node').find('.view-additional-fares');
		if( !$(this).hasClass('deactive')){
			$(this).addClass('deactive');
			additionalFares.trigger('click');
		}	
		return false;
		
	});
	
	//Any bottuns.
	
	anyButtons = ['#destination','#duration', '.dates', '.ports', '#ship', 'sequence', '#tour-duration'];
	$.each(anyButtons, function(i){
		$('#any-'+anyButtons[i].replace(/[\.,"#"]/g,'')).click( function() {
			if( $(this).hasClass('disabled') ){
				return false;
			}
			
			$(anyButtons[i]+' input:checkbox:checked').removeClass('selected').attr('checked',false);
			if( $(anyButtons[i]+' input:checkbox:checked').length == 0 ){
				$('#any-'+anyButtons[i].replace(/[\.,"#"]/g,'')).addClass('disabled');
				viewDetails();
			}
		});
	});
	toggleAny();
	
	//Sort By
	$('#order-by').change( function(){
		$('#searchResultsForm input[name=pageOffset]').val('');
		$('#searchResultsForm input[name=orderBy]').val($("option:selected", this).val());
		refreshResults();
		return false;
		
	});
	
	$('#filter-by').change( function(){
		$('#searchResultsForm input[name=pageOffset]').val('');
		$('#searchResultsForm input[name=filterBy]').val($("option:selected", this).val());
		location.href = "/find/searchResults.do?"+$('#searchResultsForm').serialize();
		return false;
		
	});
	
	$('.select-room-type input').click(function(){
		$('#searchResultsForm input[name=pageOffset]').val('');
		refreshResults();
	});
	
	//View More
	$('#show-more a').click( function(){
		offset = $('#searchResultsForm input[name=pageOffset]');
		offset.val(offset.val() == '' ? 1 : parseInt(offset.val())+1 );  
		$.ajax({
			type: "GET",
			cache: false,
			url:  removeParameter("/find/getSearchResults.rdat?"+$('#searchResultsForm').serialize(), 'itinId'),
			dataType: "html",
			success: function( results ){
				removePromoElements($(results));
				
				total = parseInt($('#total-results-count').val());
				view = parseInt($('#view-more-count').val());
				
				$('#search-results .results-node:last').after($('<div class="slider"></div>').append(results).hide());
				$('.slider').slideDown('3000',function(){
					$(this).zap();
					listFbLike();
				});
				
				returned = parseInt($(results).filter('.results-node').length);
				showing = parseInt($('.results-showing:first').text()) + returned;
				$('.results-showing').text(showing);

				if( showing == total ){
					$('#show-more a').hide();
				}
				else{
					remaining = total - showing;
					if( view > remaining ){
						itinRemaining = $('#remaining-itineraries-to-show');	
					 	if( remaining == 1 ){
					 		itinRemaining.text(remaining+' ');
							$('#show-more a').html($('#show-more a').html().replace('Itineraries','Itinerary'));
					 	}
					 	else{
					 		itinRemaining.text(remaining+' ');	 
					 	}
					}
					else{
						$('#remaining-itineraries-to-show').text(view+' ');
					}
				}
				searchResults.missingMapThmb();
				if($('.govt-tax-fees, .other-pricing-details .see-pay, .gft-summary').length > 0)			
					$(".fuel_supplement").hide();
				
			},
			error: function(req,error){
				if(error === 'error'){error = req.statusText;}
				alert('An error has occurred.');
			}
		});
		
		return false;
		
	});
	
	$('#cancel-changes').click( function(){
		$('#'+type+' input:checkbox:checked').attr('checked',false);
		var choices = $('#'+type+' input');
		choices.removeClass('default disabled').parent().removeClass('default disabled');
		choices.attr('checked',false).removeAttr('disabled');
		choices.filter('.selected').removeClass('selected');	
		choices.filter('.disabled').attr('disabled',false);
		choices.filter('.disabled').removeClass('disabled').parent().removeClass('disabled');
		
		applySearchSelections();
		
		toggleAny();
		clearQueryParams();
		removeoverlayLayer();
        $('#matching-itineraries-slider').hide();
	
	});
	
	$(document).on('click', '#matching-itineraries-slider .button', function(){
		viewDetails();
		return false;
		
	});
	

	$(window).scroll(function() {
    	$('#matching-itineraries-slider').css('top', $(this).scrollTop()+220 + "px");
	});

	/*
    $('#search-filters #cruises input, #search-filters #cruisetours input').click(function() {
    	viewDetails();
    	return false;
    	//toggleSliderAndOverlay( $(this) );
    });
	 */
	function removePromoElements( results ){
		results.filter('input:hidden[id*="PROMO_"]').each(function(){
			currentPromoCode =  $(document).find('#PROMO_'+ $(this).val());	
			if( currentPromoCode.length > 0 ){
				$('#'+$(this).val()).remove();
				currentPromoCode.remove();			
			}
		});
	}
	
	function toggleSliderAndOverlay( elem ){
	
		if($('#overlay-layer').length >= 1){
			$('#overlay-layer').remove();
		}
        addOverlayLayer('main-content');
        var elemOffsetPosition = $(elem).offset();
        var leftPos = $('#overlay-layer').offset();
           
        $('#matching-itineraries-slider').show(function(){
			$('#matching-itineraries-slider').offset({
            	'left': Math.floor(leftPos.left),
                'top': Math.floor(elemOffsetPosition.top-60)
			});
		});
	
	}
   //Overlay Functionality

    function addOverlayLayer(targetDiv) {
        var targetElement = $('#' + targetDiv);
        $('body').append('<div id="overlay-layer"></div>');
        overlayLayer = $('#overlay-layer');
        var offset = targetElement.offset();
        var leftPos = offset.left;
        var topPos = offset.top;
        topPos = topPos + $(window).scrollTop();
        var containerHeight = targetElement.height();
        var containerWidth = targetElement.width();
        overlayLayer.height(containerHeight);
        overlayLayer.width(containerWidth);
        overlayLayer.offset({
            top: topPos,
            left: leftPos
        });
        overlayLayer.show();
    }

    function removeoverlayLayer() {
        overlayLayer.remove();
    }
	
    
    function refreshResults(){
    	$.ajax({
			type: "GET",
			cache: false,
			url: removeParameter("/find/getSearchResults.rdat?"+$('#searchResultsForm').serialize(), 'itinId'),
			dataType: "html",
			success: function( results ){
			   	$('#search-results .results-node').remove();
			
				removePromoElements($(results));
				
				total = parseInt($('#total-results-count').val());
				view = parseInt($('#view-more-count').val());
				
				returned = parseInt($(results).filter('.results-node').length);
				$('.results-showing').text(returned);
				
				
				$('#search-results').prepend($('<div class="slider"></div>').append(results).hide());
				$('.slider').delay(100).slideDown(1500,function(){
					$(this).zap();
					if( returned < total ){
						$('#show-more a').show();
					}
				});			
			},
			error: function(req,error){
				if(error === 'error'){error = req.statusText;}
				alert('An error has occurred.');
			}
		});    		
    	
    }
	
	skipGetData = false;
	var inputs = $('#'+type+' input');
	inputs.attr('checked',false).removeAttr('disabled');
	inputs.click( function() {
		$(this).toggleClass('selected');
		viewDetails();
		/*
		
		skipGetData = false;
		if( $('#destination li').length == 1 && $(this).parent('#destination li').length == 1){
			$(this).attr('checked','checked');
			alert('You must have at least 1 destination selected');
			skipGetData = true;
		}
		
		if( $('#destination li').length > 1 && $(this).attr('id') == "MA" ){
			$(this).attr('checked','checked');
			alert('You must have at least 1 destination selected');
			skipGetData = true;
		}
		
		if( !skipGetData ){
			clearQueryParams();
			$(this).toggleClass('selected');
			sendQuery( update, type, 'no-of-matching-itineraries' );
		}
		
		//Disable "Any Bottoms" if none of the inputs are marked 
		toggleAny();
		*/
		
	});
	applySearchSelections();
	sendQuery( init, "false" );

}); 

function update( xml, type ){
	
	
	/*
	var choices = $('#'+type+' input');
	choices.removeClass('default disabled').parent().removeClass('default disabled');
	choices.parent().removeClass('default disabled');
			
	$(xml).find('cruisedata M').each(function(){ // Highlighting
		theContent = $(this).text();
		activeContent = $('#'+theContent);
		activeContent.addClass('default').removeAttr('disabled').parent().removeClass('disabled').addClass('default').show();
	});
	
	//Disable those that do not have any cruise				
	//choices.not(".default");
	$('#'+type+' input:checkbox:checked').not('.selected').attr('checked',false);
	choices.not('.default').addClass('disabled').parent().addClass('disabled').removeClass('default');
	choices.filter('.selected.disabled').removeClass('selected').attr('checked',false);
	choices.filter('.disabled').attr('disabled',true);
	*/
}

function init( xml, type ){

	var choices = $('#'+type+' input');
	choices.removeClass('default disabled');
			
	$(xml).find('cruisedata M').each(function(){ // Highlighting
		theContent = $(this).text();
		activeContent = $('#'+theContent);
		
		activeContent.addClass('default').parent().addClass('default').show();
	});
	
	
	if( $('#destination input:checked').attr('id') == "MA" ){
		$('#destination input').not('#sub-trade input.default, #MA').parent().remove();
		$('#destination input').not('.selected,#sub-trade input.default').parent().remove();
	}
	
	else{
		$('#destination input').not('.default').parent().remove();
	}
	
	//Disable those that do not have any cruise				
	//choices.not(".default").parent().remove();
	
	$('.dates dd').not('.default').remove();
	
	for( var i = 1; i < 4; i++ ){	 	
	 	if( $('dl.months_'+i+' dd').length == 0 ){
	 		//$('dl.months_'+i).hide();
	 		//$('ul.months_'+i).hide();	
	 	}
	} 
	toggleAny();
}

function sendAny(){
	clearQueryParams();
	sendQuery( update );
}


function toggleAny(){

	$.each(anyButtons, function(i){
		if( $(anyButtons[i]+' input:checkbox:checked').length == 0 ){
			$('#any-'+anyButtons[i].replace(/[\.,"#"]/g,'')).addClass('disabled');
		}
		else{
			$('#any-'+anyButtons[i].replace(/[\.,"#"]/g,'')).removeClass('disabled');
		}
	});

}


function removeParameter(url, parameter)
{
  var urlparts= url.split('?');

  if (urlparts.length>=2)
  {
      var urlBase=urlparts.shift(); //get first part, and remove from array
      var queryString=urlparts.join("?"); //join it back up

      var prefix = encodeURIComponent(parameter)+'=';
      var pars = queryString.split(/[&;]/g);
      for (var i= pars.length; i-->0;)               //reverse iteration as may be destructive
          if (pars[i].lastIndexOf(prefix, 0)!==-1)   //idiom for string.startsWith
              pars.splice(i, 1);
      url = urlBase+'?'+pars.join('&');
  }
  return url;
}


function applySearchSelections(){

	var inputs = $('#'+type+' input');
	$.each(searchSelections, function(key, val) { 
 		 switch(key){
 		 
 		 	case "trade":
 		 		$.each(val.split(','), function(index, value) { 
 		 			inputs.filter('#destination [value='+value+']').attr('checked','checked').addClass('selected');
 		 		});
 		 		break;	
 		 	case "filterBy":
 		 	 	$.each(val.split(','), function(index, value) { 
 		 			inputs.filter('#sub-trade [value='+value+']').attr('checked','checked').addClass('selected');
 		 		});
 		 		break;
 		 	
 		 	case "duration":
 		 		$.each(val.split(','), function(index, value) { 
 		 			inputs.filter('#duration [value='+value+']').attr('checked','checked').addClass('selected');
 		 		});
 		 		break;
 		  	
 		  	case "ship":
 		 	 	$.each(val.split(','), function(index, value) { 
 		 			inputs.filter('#ship [value='+value+']').attr('checked','checked').addClass('selected');
 		 		});
 		 		break;
 		 			
 		 	case "port":
 		 	 	$.each(val.split(','), function(index, value) { 
 		 			inputs.filter('.ports [value='+value+']').attr('checked','checked').addClass('selected');
 		 		});
 		 		break;
 		 	
 		 	case "order":
 		 	 	$.each(val.split(','), function(index, value) { 
 		 			inputs.filter('#travel-sequence [value='+value+']').attr('checked','checked').addClass('selected');
 		 		});
 		 		break;
			
			case "date":
 		 	 	$.each(val.split(','), function(index, value) { 
 		 			inputs.filter('.dates [value='+value+']').attr('checked','checked').addClass('selected');
 		 		});
 		 		break;	
 		 	
 		 	case "tourdur":
 		 	 	$.each(val.split(','), function(index, value) { 
 		 			inputs.filter('#tour-duration [value='+value+']').attr('checked','checked').addClass('selected');
 		 		});
 		 		break;	
 		 }
	});

}




